import { Outlet } from "react-router-dom";

/** Staff area. Navigation lives in the sidebar (Admin group); pages set their own breadcrumbs. */
export function AdminShell() {
  return <Outlet />;
}
